import React, { useEffect, useRef } from 'react';

const DemoWidget = () => {
    const twitterRef = useRef(null);
    const fbRef = useRef(null);

    useEffect(() => {
        // ---------------- Twitter ----------------
        // twitterRef.current.innerHTML = '';
        // const twitterAnchor = document.createElement('a');
        // twitterAnchor.setAttribute('class', 'twitter-timeline');
        // twitterAnchor.setAttribute('data-width', '400');
        // twitterAnchor.setAttribute('data-height', '600');
        // twitterAnchor.setAttribute('data-theme', 'light');
        // twitterAnchor.setAttribute('href', 'https://twitter.com/DEGSDT');
        // twitterRef.current.appendChild(twitterAnchor);

        // const twitterScript = document.createElement('script');
        // twitterScript.src = 'https://platform.twitter.com/widgets.js';
        // twitterScript.async = true;
        // twitterScript.charset = 'utf-8';
        // document.body.appendChild(twitterScript);

        // ---------------- Facebook ----------------
        const fbScript = document.createElement('script');
        fbScript.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0';
        fbScript.async = true;
        fbScript.defer = true;
        fbScript.crossOrigin = 'anonymous';
        fbScript.onload = () => {
            if (window.FB) window.FB.XFBML.parse(fbRef.current);
        };
        document.body.appendChild(fbScript);

        return () => {
             
            document.body.removeChild(fbScript);
        };
    }, []);

    return (
        <div>
            {/* Facebook Page Plugin */}
            <div ref={fbRef}>
                <div
                    className="fb-page"
                    data-href="https://www.facebook.com/DEGSDT"
                    data-tabs="timeline"
                    data-width=""
                    data-height=""
                    data-small-header="false"
                    data-adapt-container-width="true"
                    data-hide-cover="false"
                    data-show-facepile="true"
                ></div>
            </div>

            {/* Instagram Embed */}
            <iframe
                className="iframe-instagram"
                src="https://www.instagram.com/degsdt_punjab/embed"
                width="400"
                height="600"
                frameBorder="0"
                scrolling="no"
                allowTransparency="true"
                allow="encrypted-media"
                title="Instagram Embed"
            ></iframe>

            {/* YouTube Video */}
            <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/epxgncFlisM"
                title="Official YouTube video from DEGSDT"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
                sandbox="allow-scripts allow-same-origin"
            ></iframe>

            {/* Twitter Widget */}
            <div  >
            {/* style="position: static; visibility: visible; width: 250px; height: 685px; display: block; flex-grow: 1;" */}
                <iframe id="twitter-widget-0" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" class="" title="X Post" src="https://platform.twitter.com/embed/Tweet.html?creatorScreenName=MyGovIndia&amp;dnt=true&amp;embedId=twitter-widget-0&amp;features=eyJ0ZndfdGltZWxpbmVfbGlzdCI6eyJidWNrZXQiOltdLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X2ZvbGxvd2VyX2NvdW50X3N1bnNldCI6eyJidWNrZXQiOnRydWUsInZlcnNpb24iOm51bGx9LCJ0ZndfdHdlZXRfZWRpdF9iYWNrZW5kIjp7ImJ1Y2tldCI6Im9uIiwidmVyc2lvbiI6bnVsbH0sInRmd19yZWZzcmNfc2Vzc2lvbiI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfZm9zbnJfc29mdF9pbnRlcnZlbnRpb25zX2VuYWJsZWQiOnsiYnVja2V0Ijoib24iLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X21peGVkX21lZGlhXzE1ODk3Ijp7ImJ1Y2tldCI6InRyZWF0bWVudCIsInZlcnNpb24iOm51bGx9LCJ0ZndfZXhwZXJpbWVudHNfY29va2llX2V4cGlyYXRpb24iOnsiYnVja2V0IjoxMjA5NjAwLCJ2ZXJzaW9uIjpudWxsfSwidGZ3X3Nob3dfYmlyZHdhdGNoX3Bpdm90c19lbmFibGVkIjp7ImJ1Y2tldCI6Im9uIiwidmVyc2lvbiI6bnVsbH0sInRmd19kdXBsaWNhdGVfc2NyaWJlc190b19zZXR0aW5ncyI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfdXNlX3Byb2ZpbGVfaW1hZ2Vfc2hhcGVfZW5hYmxlZCI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9LCJ0ZndfdmlkZW9faGxzX2R5bmFtaWNfbWFuaWZlc3RzXzE1MDgyIjp7ImJ1Y2tldCI6InRydWVfYml0cmF0ZSIsInZlcnNpb24iOm51bGx9LCJ0ZndfbGVnYWN5X3RpbWVsaW5lX3N1bnNldCI6eyJidWNrZXQiOnRydWUsInZlcnNpb24iOm51bGx9LCJ0ZndfdHdlZXRfZWRpdF9mcm9udGVuZCI6eyJidWNrZXQiOiJvbiIsInZlcnNpb24iOm51bGx9fQ%3D%3D&amp;frame=false&amp;hideCard=false&amp;hideThread=false&amp;id=1903725618836955148&amp;lang=en&amp;origin=https%3A%2F%2Fmygov.in%2F&amp;sessionId=fb1a5c51b12af806a09f68203f40a679aa993bd5&amp;siteScreenName=MyGovIndia&amp;theme=light&amp;widgetsVersion=2615f7e52b7e0%3A1702314776716&amp;width=550px"  data-tweet-id="1903725618836955148"></iframe>
            </div>
        </div>
    );
};

export default DemoWidget;
